import type { Middleware } from '@floating-ui/vue'
import { size } from '@floating-ui/vue'
import type { PartialRecord } from '@/core/helperTypes'

export const PopOverMiddleware = {
  SameWidthAsTarget: 'target-width',
} as const

export type PopOverMiddleware = (typeof PopOverMiddleware)[keyof typeof PopOverMiddleware]
export const popOverMiddlewares: PartialRecord<PopOverMiddleware, Middleware> = {
  /** Makes sure the pop over content has the same size (in width) as the trigger/target */
  [PopOverMiddleware.SameWidthAsTarget]: size({
    apply({ rects, elements }) {
      Object.assign(elements.floating.style, {
        width: `${rects.reference.width}px`,
      })
    },
  }),
}
